import "../css/constants.css";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useWindowDimensions } from "../contexts/WindowDimensionsContext.jsx";
import PresentationTexts from "../assets/jsons/Presentation.json";

export default function Presentation({ language }) {
    const windowDimensions = useWindowDimensions();
    const [hasAnimated, setHasAnimated] = useState(false);

    // Text content state (can later be internationalized or externalized)
    const [content] = useState({
        name: "THE ART OF MOVING FORWARD",
        title: "Votre voyage privé réinventé, avec élégance.",
        freelance: "Available for Full-Time or Freelance Opportunities.",
        description: "I specialize in front-end and back-end development with expertise in React, Node.js, and low-level programming (C, C++). I design scalable, high-performance software solutions, delivering innovative results that foster growth and success while staying at the forefront of emerging technologies.",
        numberYearsExperience: "8",
        textYearsExperience: "Years of Experience",
        numberSuccessfulProjects: "0",
        textSuccessfulProjects: "Successful Projects",
        downloadCV: "Download my CV",
        goToCompetencies: "ABOUT ME",
        openWork: "Open to work",
        based: "Based in France",
    });

    const [tooltips, setTooltips] = useState({
        linkedin: false,
        mail: false,
        whatsapp: false,
        phone: false,
        upwork: false,
    });

    useEffect(() => {
        if (!hasAnimated) {
            const timer = setTimeout(() => setHasAnimated(true), 600);
            return () => clearTimeout(timer);
        }
    }, [hasAnimated]);

    const textVariants = {
        initial: { opacity: 0, y: -100 },
        animate: hasAnimated
            ? {
                opacity: 1,
                y: 0,
                transition: {
                    stiffness: 90,
                    damping: 75,
                    duration: 0.6,
                },
            }
            : {},
    };

    const CardDesktop = () => (
        <section name="presentation" className=" relativez-10">
            <div className="min-h-lvh flex">
                <div className="mt-32 px-12 mx-auto w-full">
                    <div className="flex-col-center items-center">
                        <motion.div>
                            <motion.h1
                                transition={{ duration: 0.6 }}
                                className="text-5xl sm:text-6xl font-extrabold tracking-tight leading-tight text-center"
                            >
                                {PresentationTexts.availableLanguages[language].title1} <span className="text-[#C1A45F]">{PresentationTexts.availableLanguages[language].title2}</span> {PresentationTexts.availableLanguages[language].title3} <span className="text-[#C1A45F]">{PresentationTexts.availableLanguages[language].title4}</span>
                            </motion.h1>
                            <p className="mt-2 text-2xl sm:text-3xl text-white max-w-3xl text-center mx-auto">
                                {PresentationTexts.availableLanguages[language].subtitle1} <strong className="text-[#C1A45F]">{PresentationTexts.availableLanguages[language].subtitle2}</strong>{PresentationTexts.availableLanguages[language].subtitle3}
                            </p>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );

    return windowDimensions.wWCheck(700) ? <CardDesktop /> :  "";
}
